class MultiquoteDebugPermissions {
    constructor({ show = false } = {}) {
        this.show = show
    }
}

export default MultiquoteDebugPermissions
